module.exports = __webpack_public_path__ + "img/patients.fbcc9ded.jpg";